import { createBrowserRouter, type RouteObject } from 'react-router';
import { AdminLayout } from './admin/AdminLayout';
import { BetaCodesPage } from './admin/BetaCodesPage';
import { ChestDetailPage } from './admin/ChestDetailPage';
import { ChestsPage } from './admin/ChestsPage';
import { ItemDetailPage } from './admin/ItemDetailPage';
import { ItemsPage } from './admin/ItemsPage';
import { LogsPage } from './admin/LogsPage';
import { OverviewPage } from './admin/OverviewPage';
import { PlayerDetailPage } from './admin/PlayerDetailPage';
import { PlayersPage } from './admin/PlayersPage';
import { SortPlanPage } from './admin/SortPlanPage';
import { SortPlansPage } from './admin/SortPlansPage';
import { StatsPage } from './admin/StatsPage';
import { TeamDetailPage } from './admin/TeamDetailPage';
import { TeamsPage } from './admin/TeamsPage';
import { UiPage } from './dev/UiPage';
import { GameLoginPage } from './portal/GameLoginPage';
import { HomePage } from './portal/HomePage';
import { NotFoundPage } from './portal/NotFoundPage';
import { PrivacyPage } from './portal/PrivacyPage';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  // Ziel der Fehlerweiterleitungen (`/login?error=…`)
  { path: '/login', element: <HomePage /> },
  // Einmal-Link aus dem Spiel (`#<token>`), architecture.md 4.2
  { path: '/login/game', element: <GameLoginPage /> },
  { path: '/datenschutz', element: <PrivacyPage /> },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <OverviewPage /> },
      { path: 'players', element: <PlayersPage /> },
      { path: 'players/:id', element: <PlayerDetailPage /> },
      { path: 'teams', element: <TeamsPage /> },
      { path: 'teams/:id', element: <TeamDetailPage /> },
      { path: 'chests', element: <ChestsPage /> },
      { path: 'chests/:id', element: <ChestDetailPage /> },
      { path: 'items', element: <ItemsPage /> },
      { path: 'items/:id', element: <ItemDetailPage /> },
      { path: 'beta-codes', element: <BetaCodesPage /> },
      { path: 'logs', element: <LogsPage /> },
      { path: 'stats', element: <StatsPage /> },
      { path: 'sort-plans', element: <SortPlansPage /> },
      { path: 'sort-plans/:id', element: <SortPlanPage /> },
    ],
  },
];

// Interne Musterseite nur im Dev-Modus; im Produktions-Build fällt sie weg.
if (import.meta.env.DEV) routes.push({ path: '/_ui', element: <UiPage /> });
routes.push({ path: '*', element: <NotFoundPage /> });

export const router = createBrowserRouter(routes);
